import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_9rhufegspe_thi_f5e67f7f3a: FaireThemeEntity = {
  token: "board_demo_r_9rhufegspe_thi_f5e67f7f3a",
  type: "theme",
  retailerToken: "r_9rhufegspe",
  name: "Whimsical Paper Goods and Hand-Crafted Clips",
  description:
    "Curated paper goods and hair accessories that emphasize the 'hand-painted' and 'artist-designed' qualities your customers look for in your pop-up shop.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/9b28ed18f75fade8290faabf908d6472bbb1bfe3a4afb72f0e13aa94bbd92cc1.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/9b28ed18f75fade8290faabf908d6472bbb1bfe3a4afb72f0e13aa94bbd92cc1.jpeg",
    "https://cdn.faire.com/fastly/debbe422a5ad633a090b875d3c8d74f0889cc4d6a85eddb6bca41a0a360b1431.jpeg",
    "https://cdn.faire.com/fastly/5481f50713e62c934e2b0d0714cd1ffdb884b81d2e80ab1a2e75b22bebfaa915.jpeg",
    "https://cdn.faire.com/fastly/bc93c4a28b04cf04783aeb9c14e4b9ef3b512d7f1cd4067ec1c13c76ffd957d5.jpeg",
    "https://cdn.faire.com/fastly/8e35b7946fe4f7dfaff5db0fa1e5d6d43a31ef72d8de51b50f339381fa277aee.jpeg",
    "https://cdn.faire.com/fastly/31b58c877bc065735d7c75befe8eb8cacf915e46b86aaf9e7635c9c1e134f300.jpeg",
  ],
  itemCount: 17,
  source: "eric_themes_ideas",
  teaser: "thi_f5e67f7f3a",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
